import { FeatureType } from 'common/types';

const shouldShowVenueSelector = (
  selectedFeature: FeatureType | undefined,
  hasVenuesVenueGroupsOrMerchants: boolean,
  isEmployee: boolean,
) => {
  if (['merchant-sign-up', 'identity-verification', 'venue-data-collection'].includes(selectedFeature || '')) {
    return false;
  }
  if (hasVenuesVenueGroupsOrMerchants) {
    return true;
  }
  return isEmployee;
};
export default shouldShowVenueSelector;
